import './sass';
import './Carousel';  // 轮播
import './Article'; // 文章内容
import './ErrorPage';// 404
import './Font';
import './ListLink';
import './Map';
import './Agenda';  // 时间计划
import './Block';   // 区块
import './Breadcrumb'; // 面包屑导航
import './Resume'; // 个人简历
import './Footer'; // 页尾
import './Header'; // 页头
import './Nav'; // 导航条
import './Select'; // 下拉框
import './Pagination'; // 分页
import './PicNews'; // 图片新闻
import './Tab'; // 标签
import './Affix'; // 固钉
import './Video';
import './LayoutAside';
import './Banner';
import './Modal';
import './Slick';
import './Dropdown';
import './Collapse';
import './Drawer';




/** WEBPACK FOOTER **
 ** ./components/main.js
 **/